// noinspection ES6UnusedImports
import {Icon, IconButton, Button} from '@bonprix/design-system';
import Landmark from '@core/scripts/components/landmark-adapter';
import CoreMessages from '@core/scripts/components/message-list';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import React, { useEffect, useRef, useState } from 'react';
import WishlistMessages from './messages';
import acquireWishlistState, { acquireWishlistStateByDigistyleId } from '../helper/acquire-wishlist-state';
import addToWishlist from '../helper/add-to-wishlist';
import removeFromWishlist from '../helper/remove-from-wishlist';
import WishlistLandmarks from '../helper/wishlist-landmarks';
import Messages from './messages';
import TrackingHelper from '@core/scripts/components/tracking/helper';

// DEPRECATED! Use WishlistHeart.jsx instead
// TODO: Remove zgaMode wenn sich die Icon-Frage gelöst hat.
const SHIFT_COMPENSATION_THRESHOLD = 0.95;
export default function WishlistHeart({
                                          className,
                                          digistyleId,
                                          articleNumber,
                                          promotion,
                                          articlePrice,
                                          masterStyleId,
                                          itemOptionName,
                                          shopId,
                                          itemId,
                                          itemOptionId,
                                          addLandmark,
                                          removeLandmark,
                                          onHideError = null,
                                          onAddSuccess = null,
                                          onAddError = null,
                                          onRemoveError = null,
                                          onRemoveSuccess = null,
                                          zgaMode = false,
                                          origin,
                                          children,
                                          testRefs = {},
                                          fktId = "",
                                          isMultiItem
                                      }) {
    const [isOnWishlist, setIsOnWishlist] = useState(false);

    const wishlistItemOffset = useRef(0);
    const previousHeartOffset = useRef(0);
    const loading = useRef(false);
    const lastClick = useRef(new Date());
    const containerRef = useRef(null);
    const currentDigistyleId = useRef(digistyleId);
    const currentItemId = useRef(itemId);
    const initialStateFetched = useRef(false);

    useEffect(() => {
        const itemCountChanged = MessageBroker.subscribe(
            Messages.WISHLIST.ITEM_COUNT_CHANGED,
            (countData) => {
                if (previousHeartOffset.current === 0) return;
                const rawShift = previousHeartOffset.current - containerRef.current.getBoundingClientRect().top;
                const absoluteShift = Math.abs(rawShift);
                if (
                    wishlistItemOffset.current &&
                    absoluteShift >= wishlistItemOffset.current * SHIFT_COMPENSATION_THRESHOLD
                ) {
                    if (rawShift > 0) {
                        window.scrollTo(0, window.scrollY - wishlistItemOffset.current);
                    }
                    if (rawShift < 0) {
                        window.scrollTo(0, window.scrollY + wishlistItemOffset.current);
                    }
                    wishlistItemOffset.current = 0;
                }
                previousHeartOffset.current = 0;
                return () => {
                    MessageBroker.unsubscribe(itemCountChanged);
                };
            },
            [wishlistItemOffset]
        );
    });

    useEffect(() => {
        const subscriptions = [
            MessageBroker.subscribe(WishlistMessages.WISHLIST.ITEM_DELETED, (wishlistRemovalPayload) => {
                const styleId = isMultiItem ? currentDigistyleId.current : digistyleId;
                const actualItemId = isMultiItem ? currentItemId.current : itemId;
                if(wishlistRemovalPayload.digistyleId === Number(styleId) &&
                    (zgaMode || wishlistRemovalPayload.itemId === Number(actualItemId))) {
                    setIsOnWishlist(false);
                }
            }),
            MessageBroker.subscribe(WishlistMessages.WISHLIST.ITEM_ADDED, (wishlistAdditionContext) => {
                const styleId = isMultiItem ? currentDigistyleId.current : digistyleId;
                const actualItemId = isMultiItem ? currentItemId.current : itemId;
                if(wishlistAdditionContext.digistyleId === Number(styleId) &&
                    (zgaMode || wishlistAdditionContext.itemId === Number(actualItemId))) {
                    setIsOnWishlist(true);
                }
            }),
        ];
        if (isMultiItem) {
            subscriptions.push(
                MessageBroker.subscribe(CoreMessages.WISHLIST_ITEM_CHANGE, ({productId, itemId}) => {
                    if (productId === digistyleId) {
                        if (productId) {
                            currentDigistyleId.current = productId;
                        }
                        if (itemId) {
                            currentItemId.current = itemId;
                        }
                        const fetchWishlistState = zgaMode ? acquireWishlistStateByDigistyleId : acquireWishlistState;
                        loading.current = true;
                        fetchWishlistState(currentDigistyleId.current, currentItemId.current).then((onWishlist) => {
                            setIsOnWishlist(onWishlist);
                            loading.current = false;
                        });
                    }
                })
            );
        }

        return () => subscriptions.forEach(subscription => MessageBroker.unsubscribe(subscription));
    }, []);

    if (!initialStateFetched.current) {
        const fetchWishlistState = zgaMode ? acquireWishlistStateByDigistyleId : acquireWishlistState;
        loading.current = true;
        fetchWishlistState(digistyleId, itemId).then((onWishlist) => {
            setIsOnWishlist(onWishlist);
            loading.current = false;
        }).finally(() => {
            initialStateFetched.current = true;
        });
    }

    const onClick = () => {
        if (loading.current || Date.now() - lastClick.current <= 500) {
            return;
        }
        lastClick.current = Date.now();
        loading.current = true;
        onHideError?.();

        if (origin === 'wishlist_carousel' && containerRef.current) {
            try {
                const wishlistElement = document.getElementsByClassName('wishlist-item')[0];
                const itemHeight =
                    wishlistElement.offsetHeight +
                    parseInt(getComputedStyle(wishlistElement).marginTop) +
                    parseInt(getComputedStyle(wishlistElement).marginBottom);
                if (itemHeight) {
                    wishlistItemOffset.current = itemHeight;
                    previousHeartOffset.current = containerRef.current.getBoundingClientRect().top;
                }
            } catch {
                // no wishlist items present
            }
        }
        if (isOnWishlist) {
            removeArticleFromWishlist();
        } else {
            addArticleToWishlist();
        }
    };

    const addArticleToWishlist = () => {
        if (addLandmark != null) {
            Landmark.sendClickLandmark(addLandmark);
        }
        const actualStyleId = isMultiItem ? currentDigistyleId.current : digistyleId;
        const actualItemId = isMultiItem ? currentItemId.current : itemId;
        const eventId = TrackingHelper.generateUUID()
        addToWishlist(
            actualStyleId,
            shopId,
            actualItemId,
            articleNumber,
            itemOptionId,
            eventId
        ).then(() => {
            setIsOnWishlist(true);
            onAddSuccess?.();
            WishlistLandmarks.sendWishListItemAddLandMark({
                itemOptionName,
                articleNumber,
                promotion,
                articlePrice,
                shopId,
                digistyleId: actualStyleId,
                masterStyleId,
                itemId: actualItemId,
                itemOptionId,
                origin,
                fktId,
                eventId
            });
            loading.current = false;
        }).catch((error) => {
            MessageBroker.publish(CoreMessages.WISHLIST.SHOW_ERROR_LAYER, {error: error.message});
            onAddError?.(error.message);
            loading.current = false;
        });
    };

    const removeArticleFromWishlist = () => {
        if (removeLandmark) {
            Landmark.sendClickLandmark(removeLandmark);
        }
        const actualStyleId = isMultiItem ? currentDigistyleId.current : digistyleId;
        const actualItemId = isMultiItem ? currentItemId.current : itemId;
        removeFromWishlist(
            actualStyleId,
            zgaMode ? null : actualItemId
        ).then(() => {
            setIsOnWishlist(false);
            onRemoveSuccess?.();
            WishlistLandmarks.sendWishListItemRemoveLandMark({
                itemOptionName,
                articleNumber,
                promotion,
                articlePrice,
                shopId,
                digistyleId: actualStyleId,
                masterStyleId,
                itemId: actualItemId,
                itemOptionId,
                origin,
                fktId,
            });
            loading.current = false;
        }).catch(() => {
            onRemoveError?.();
            loading.current = false;
        });
    };

    //workaround for using the new button of the design system
    //whilst relying on the wishlist logic provided by WishlistHeart component
    if(className === 'design-system-button') {
        return <IconButton
            onClick={onClick}
            variant="secondary"
            icon={isOnWishlist ? 'heart-full' : 'heart'}
            iconPosition="end">{children}</IconButton>;
    }

    if (className === 'design-system-button-with-text') {
        return (
            <Button
                icon={isOnWishlist ? 'heart-full' : 'heart'}
                iconPosition="end"
                onClick={onClick}
                variant="secondary"
                fullWidth={true}
            >
                {children}
            </Button>
        );
    }


    return (
        <div
            ref={containerRef}
            className={className + (isOnWishlist ? ' is-favored' : '')}
            onClick={onClick}
            {...testRefs}
        >
            {children}
            <Icon variant={isOnWishlist ? 'heart-full' : 'heart'} className={'icon'}></Icon>
        </div>
    );
}
